export const RESPONSE_TIME_VARIES = 'Response time varies';

/**
 * Checks if a user name matches the "Ask Anonymously" pattern.
 * Matches 'anonymous' or 'anonymously' (case-insensitive).
 *
 * @param name - The user's name to check
 * @returns True if the name matches the anonymous pattern, false otherwise
 */
export const isAskAnonymously = (name?: string | null) => {
  return name ? /anonym(?:ous|ously)/i.test(name) : false;
};

/**
 * Checks if a user name matches the "Primum Support" pattern.
 * Matches 'primum support' (case-insensitive).
 *
 * @param name - The user's name to check
 * @returns True if the name matches the Primum Support pattern, false otherwise
 */
export const isPrimumSupport = (name?: string | null) => {
  return name ? /primum\s+support/i.test(name) : false;
};

/**
 * Checks if a directory profile is a survey rather than a person.
 *
 * Surveys reach the directory as ordinary expert-typed records — only the
 * anonymous option and product support are classified separately — so nothing
 * in the item shape distinguishes them and the name is the only signal, as it
 * is for the anonymous option above. This exists so the end-to-end suites can
 * seed a search from a real expert: a survey sits near the top of the default
 * ordering, so seeding blindly from the first card reads from it instead.
 *
 * @param name - The profile name to check
 * @returns True if the name identifies a survey profile, false otherwise
 */
export const isSurveyProfile = (name?: string | null) => {
  return name ? /\bsurveys?\b/i.test(name) : false;
};
